// extracted by mini-css-extract-plugin
module.exports = {"ForumFeedRight":"ju_a","ForumFeedRight__brandDaysPosts":"ju_b vh_ox"};